export default "__VITE_ASSET__zS3ppnyC__"